import { useState } from "react"
import { IconAtom2Outline18 as Atom } from "nucleo-ui-outline-18"

import { Button, Textarea } from "@productlane/ui"

import { toast } from "@/components/toast"
import { api } from "@/lib/api"

/** Learning is explicit; a generated suggestion never replaces saved guidance. */
export function LearnWritingStyleButton({
	onApply,
}: {
	onApply: (style: string) => void
}) {
	const mutation = api.workspace.suggestDraftsCustomPrompt.useMutation()
	const [suggestion, setSuggestion] = useState<string | null>(null)
	return (
		<div className="mt-3 flex flex-col gap-2">
			<div className="flex justify-end">
				<Button
					variant="outline"
					size="sm"
					Icon={Atom}
					disabled={mutation.isLoading}
					onClick={async () => {
						try {
							const result = await mutation.mutateAsync()
							setSuggestion(result.prompt)
						} catch (error) {
							toast.info({
								title:
									error instanceof Error
										? error.message
										: "Could not learn a writing style",
								description: "Your saved instructions are unchanged.",
							})
						}
					}}
				>
					{mutation.isLoading
						? "Reading your replies..."
						: "Learn writing style from replies"}
				</Button>
			</div>
			{suggestion !== null && (
				<>
					<p className="text-xs text-gray-500">
						Review the style learned from your team&apos;s sent replies. Adding
						it keeps your existing instructions.
					</p>
					<Textarea
						variant="settings"
						name="suggestedWritingStyle"
						aria-label="Suggested writing style"
						value={suggestion}
						onChange={(e) => setSuggestion(e.target.value)}
						rows={4}
					/>
					<div className="flex justify-end gap-2">
						<Button
							variant="outline"
							size="sm"
							onClick={() => setSuggestion(null)}
						>
							Discard
						</Button>
						<Button
							size="sm"
							disabled={!suggestion.trim() || mutation.isLoading}
							onClick={() => {
								onApply(suggestion.trim())
								setSuggestion(null)
							}}
						>
							Add to instructions
						</Button>
					</div>
				</>
			)}
		</div>
	)
}
